import Head from 'next/head';
import React, { useEffect } from 'react';
import { TermsConditions } from '../../components';
import { withLayout } from '../../Layout/Layout';

export const TNCHOC = ({ setCookieAccepted }) => {
  useEffect(() => {
    setTimeout(() => {
      setCookieAccepted({
        accepted: false,
        opened: false,
      });
    }, 0);

  }, [setCookieAccepted]);
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/terms_conditions`} />
      </Head>
      <TermsConditions />
    </>
  );
};
export default withLayout(TNCHOC, true);
